import React from 'react';
import processIcon from '../image/process.png';
import playIcon from '../image/play.png';

const ProcessTable = ({ videoProcesses, handlePlayClick ,tableWidth}) => {
  return (
    <div className="right-grid">
      <table className="play-table"  style={{ width: tableWidth }}>
        <tbody>
          {videoProcesses.map((process, index) => (
            <React.Fragment key={index}>
              <tr>
                <td className="process-name">
                  <p className="process-text" style={{ fontFamily: 'Calibri' }}>
                    {process.name}
                  </p>
                </td>
                {process.name === 'Process' ? (
                  <td>
                    <button className="process-button" onClick={() => handlePlayClick(process,'pdf')}>
                    <img 
                    src={processIcon} 
                    alt="Process" 
                    style={{ 
                      width: '26px', 
                      height: '26px', 
                      borderRadius: '50%' 
                    }} 
                  />

                    </button>
                  </td>
                ) : (
                  <td>
                    <button className="play-button" onClick={() => handlePlayClick(process,'video')}>
                      <img src={playIcon} alt="Process" className="play-icon" />
                    </button>
                  </td>
                )}
              </tr>
              {process.name === 'Process' && (
                <tr>
                  <td colSpan="2">&nbsp;</td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProcessTable;
